let _version = 0;
let _versionBar = 1.5;

class AppHelper {
  static storeAppVersion(versionNo) {
    _version = versionNo;
  }

  static get skipUrlEncode() {
    return _version >= _versionBar;
  }
}

export default AppHelper;



// WEBPACK FOOTER //
// ./src/helpers/AppHelper.js